import ComboBoxItem from "components/ComboBox/ComboBoxItem";

const TEAM_SIZES: ComboBoxItem<string>[] = [
  { id: 0, label: "1 (Solo Founder/Individual)", value: "1" },
  { id: 1, label: "2-5", value: "2-5" },
  { id: 2, label: "6-10", value: "6-10" },
  { id: 3, label: "11-20", value: "11-20" },
  { id: 4, label: "21-100", value: "21-100" },
  { id: 5, label: "> 100", value: "> 100" },
];

export default TEAM_SIZES;
